export const DELETE_STANDARD = 'standardDelete';
export const DELETE_SOFT = 'softDelete';
export const DELETE_PERMANENT = 'permanentDelete';
